import { ZenitEventName, ZenitEventParam } from '../models/zenit-general.model';

export const ZenitEventsContextConfigs: Record<ZenitEventName, ZenitEventParam[]> = {
    PageHit: [
        'brandId',
        'categoryId',
        'categoryURL',
        'catentryId',
        'currency',
        'displayLanguage',
        'experiments',
        'pageType',
        'partnumber',
        'section',
        'storeId',
        'universe',
    ],
    AddToCart: [
        'brandId',
        'cartId',
        'categoryId',
        'categoryURL',
        'catentryId',
        'displayLanguage',
        'experiments',
        'isRecommended',
        'list',
        'listPosition',
        'pageType',
        'partnumber',
        'recommender',
        'section',
        'skus',
        'storeId',
        'universe',
    ],
    Click: [
        'action',
        'assetId',
        'brandId',
        'categoryId',
        'categoryURL',
        'catentryId',
        'displayLanguage',
        'experiments',
        'isRecommended',
        'list',
        'listPosition',
        'pageType',
        'partnumber',
        'personalization',
        'quantity',
        'recommender',
        'section',
        'sku',
        'storeId',
        'templateType',
        // 'suggestions', // Funcionalidad actualmente no implementada en el buscador de MD
        'universe',
        'viewOrigin',
        'zoomLevel',
    ],
    ImpressionsHit: [
        'assetId',
        'brandId',
        'categoryId',
        'categoryURL',
        'catentryId',
        'displayLanguage',
        'experiments',
        'list',
        'listPosition',
        'pageType',
        'partnumber',
        'personalization',
        'section',
        'storeId',
        'templateType',
        'universe',
        'viewOrigin',
        'zoomLevel',
    ],
    PurchaseConfirmed: [
        'cartId',
        'currency',
        'displayLanguage',
        'experiments',
        'items',
        'storeId',
    ],
    SearchAssistant: [
        'pageType',
        'storeId',
        'brandId',
        'section',
        'displayLanguage',
        'searchRequestHTTPResponseCode',
        'searchRequestMethodName',
        'searchRequestQuery',
        'searchRequestResponseTime',
        'searchRequestResultsNum',
        'searchRequestLocale',
        'searchRequestOffset',
        'searchRequestLimit',
        'searchRequestFilters',
        'searchRequestProvider',
        'searchRequestPass',
        'universe',
    ],
};

export const modalsIncluded: string[] = [
    'shop-cart-packagin',
];
